"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$lawRef = exports.$lawNum = void 0;
const std = __importStar(require("../../../law/std"));
const controls_1 = require("../../../node/el/controls");
const env_1 = require("../env");
const factory_1 = __importDefault(require("../factory"));
exports.$lawNum = factory_1.default
    .withName("nameInline")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.____LawNum)) {
        return item;
    }
    else {
        return null;
    }
}), "lawNum")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .zeroOrOne(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /以下(?:単に)?$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
})), "following")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.____PointerRanges)) {
        return item;
    }
    else {
        return null;
    }
}))
    .andOmit(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /^において(?:単に)?$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
})))), "pointerRanges")
    .andOmit(r => r
    .assert(({ following, pointerRanges }) => following || pointerRanges))
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Parentheses)
        && item.attr.type === "square"
        && item.content.children.every(c => c instanceof controls_1.__Text)) {
        return item;
    }
    else {
        return null;
    }
}), "nameSquareParentheses")
    .andOmit(r => r
    .zeroOrOne(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /^という。/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
})))
    .action(({ following, pointerRanges, nameSquareParentheses }) => {
    const value = {
        following: Boolean(following),
        pointerRanges,
        nameSquareParentheses,
    };
    return { value, errors: [] };
}))), "aliasInfo")
    .action(({ lawNum, aliasInfo }) => {
    const value = {
        lawNum,
        aliasInfo: aliasInfo?.value ?? null,
    };
    return { value, errors: [...(aliasInfo?.errors ?? [])] };
}));
exports.$lawRef = factory_1.default
    .withName("lawRef")
    .sequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .choice(c => c
    .or(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)) {
        return item;
    }
    else {
        return null;
    }
}))
    .or(r => r
    .oneMatch(({ item }) => {
    if ((std.isRuby(item) || std.isSup(item) || std.isSub(item))) {
        return item;
    }
    else {
        return null;
    }
})))), "lawTitleCandidates")
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Parentheses)
        && item.attr.type === "round") {
        const match = exports.$lawNum.match(0, item.content.children, (0, env_1.initialEnv)({ target: "" }));
        if (!match.ok)
            return null;
        return {
            value: {
                ...match.value.value,
                lawRefParentheses: item,
            },
            errors: match.value.errors,
        };
    }
    else {
        return null;
    }
}), "lawRefInfo")
    .action(({ lawTitleCandidates, lawRefInfo }) => {
    const value = {
        lawTitleCandidates,
        lawRefInfo: lawRefInfo.value,
    };
    return { value, errors: [...lawRefInfo.errors] };
}));
exports.default = exports.$lawRef;
//# sourceMappingURL=$lawRef.js.map